import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { colors, rem, zIndex, getResetByTag, utilityStyles } from '../../../../styles';
import StyledModalSubHeaderInner from './styles/modal.subheader.inner.styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("background-color:", colors.white, ";color:", colors.navy_500, ";display:flex;flex-shrink:0;padding:", rem(0, 0, 0, 16), ";position:relative;width:100%;z-index:", zIndex.zIndex_1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var hasBorderStyles = function hasBorderStyles(_ref) {
  var hasBorder = _ref.hasBorder,
    isInverse = _ref.isInverse;
  if (hasBorder) {
    return /*#__PURE__*/css(StyledModalSubHeaderInner, "{border-bottom:", isInverse ? "".concat(rem(1), " solid ").concat(colors.navy_400) : "".concat(rem(1), " solid ").concat(colors.coolGray_500), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:hasBorderStyles;"));
  }
};
var isFlushPaddingStyles = function isFlushPaddingStyles(_ref2) {
  var isFlushPadding = _ref2.isFlushPadding;
  if (isFlushPadding) {
    return /*#__PURE__*/css("padding:0;", StyledModalSubHeaderInner, "{padding:0;z-index:", zIndex.zIndex_1, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:isFlushPaddingStyles;"));
  }
};
var isInverseStyles = function isInverseStyles(_ref3) {
  var isInverse = _ref3.isInverse;
  if (isInverse) {
    return /*#__PURE__*/css("background:", colors.navy_500, ";color:", colors.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:isInverseStyles;"));
  }
};
var actionButtonStyles = function actionButtonStyles(_ref4) {
  var actionButton = _ref4.actionButton;
  if (actionButton) {
    return /*#__PURE__*/css(StyledModalSubHeaderInner, "{padding-bottom:0;&>button{transform:translateY(50%);}}&+div{padding-top:", rem(38), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:actionButtonStyles;"));
  }
};
var variantStyles = function variantStyles(_ref5) {
  var variant = _ref5.variant;
  if (variant) {
    switch (variant) {
      case 'gray':
        return /*#__PURE__*/css("background:", colors.coolGray_100, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
      case 'cool-gray':
        return /*#__PURE__*/css("background:", colors.coolGray_200, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    }
  }
};
var resetStyles = getResetByTag('div');
var StyledModalSubHeader = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1syb0x60"
} : {
  target: "e1syb0x60",
  label: "StyledModalSubHeader"
})(resetStyles, defaultStyles, hasBorderStyles, isFlushPaddingStyles, isInverseStyles, actionButtonStyles, variantStyles, utilityStyles);
export default StyledModalSubHeader;